import type { Viewport } from "pixi-viewport";
import { tileWidth, type MosaicContainer } from "./particle";

// import { Graphics } from "pixi.js";

// todo: a white border around the viewport
export const fitToScreen = (
  rect: { width: number; height: number },
  viewport: Viewport,
  pc: MosaicContainer,
  setScale = false
) => {
  // The scale is based on the number of particles & the screen. Each particle is 20x20 tile.
  // the pc has a gridW and gridH that represent the pixel dimensions
  const world = {
    width: pc.computedWidth,
    height: pc.computedHeight,
  };
  viewport.resize(rect.width, rect.height, world.width, world.height);

  const scale = Math.min(rect.width / world.width, rect.height / world.height);
  viewport.clamp({ direction: "all" });
  viewport.clampZoom({
    minScale: scale,
    maxScale: 1,
  });

  // set scale if current scale is less than the new scale
  if (setScale || viewport.scale.x < scale) {
    viewport.scale.set(scale);
  }
};

export const hintPan = (
  colIdx: number,
  vp: Viewport,
  pc: MosaicContainer
): boolean => {
  // break into 10 x 10 tiles to find the block with the most matches
  let found: [number, number] | undefined;
  let foundSize = 0;
  const blockSize = 10;
  for (let x = 0; x < pc.gridW; x += blockSize) {
    for (let y = 0; y < pc.gridH; y += blockSize) {
      const matches = pc.getUncolouredInBlock(colIdx, x, y, blockSize);
      if (matches.length > foundSize) {
        foundSize = matches.length;
        found = [x, y];
      }
    }
  }

  if (!found) {
    console.warn("No matches found for hint pan");
    return false;
  }

  const halfBlock = Math.floor(blockSize / 2);
  const worldX = (found[0] + halfBlock) * tileWidth + tileWidth / 2;
  const worldY = (found[1] + halfBlock) * tileWidth + tileWidth / 2;

  vp.animate({
    position: { x: worldX, y: worldY },
    scale: 1,
    ease: "easeInOutSine",
    removeOnInterrupt: true,
  });

  return true;
};

export const fitAnimate = (vp: Viewport, onComplete?: () => void) => {
  const duration = 1000; // ms
  // Target scale to fit world into screen
  const scaleX = vp.screenWidth / vp.worldWidth;
  const scaleY = vp.screenHeight / vp.worldHeight;
  const targetScale = Math.min(scaleX, scaleY);

  // Target center of the world
  const targetX = vp.worldWidth / 2;
  const targetY = vp.worldHeight / 2;

  vp.animate({
    time: duration, // ms
    position: { x: targetX, y: targetY },
    scale: targetScale,
    ease: "easeInOutSine", // or any supported easing
    removeOnInterrupt: false,
    callbackOnComplete: onComplete,
  });
};
